<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		<div class="list-btn">
			<Cascader style="width: 200px;" placeholder="请选择片区" :data="data4" :load-data="loadData" :change-on-select="true" :not-found-text="kong" @on-change="onChange"></Cascader>
			
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}12</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>
				<Button type="delete" size="small" style="margin-right: 5px" @click="forbidden(row.id)" title="重置密码后,密码为88888888">重置密码</Button>
			     <Modal v-model="modal2" width="360">
			    	<p slot="header" style="color:#f60;text-align:center">
			    		<Icon type="ios-information-circle"></Icon>
			    		<span>重置密码</span>
			    	</p>
			    	<div style="text-align:center">
			    		<p>确定重置密码？</p>
			    	</div>
			    	<div slot="footer">
			    		<Button type="error" size="large" long :loading="modal_loading"  @click="reset()">确定</Button>
			    	</div>
			    </Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	let _this
	export default {
		data() {
			return {
				
				queryDistrict:{
					page:0,
					size:100,
					parentId:null
				},
				//级联属性
				data4:[],
				kong:'暂无下级',
				//级联属性
				loading:false,
				total:0,
				columns12: [
					
					{
						title: 'id',
						key: 'id',
						width:120,
						align:'center',
					},
					{
						title: '姓名',
						key: 'name',
						width:120,
						align:'center',
					},
					{
						title: '所属片区',
						key: 'districtName',
						width:150,
						align:'center',
					},
					{
						title: '类型',
						key: 'empTypeString',
						width:120,
						align:'center',
					},
					{
						title: '联系方式',
						key: 'phone',
						width:150,
						align:'center',
					},
					{
						title: '住址',
						key: 'address',
						width:150,
						align:'center',
					},
					{
						title: '登陆账号',
						key: 'username',
						width:150,
						align:'center',
					},
					{
						title: '状态',
						key: 'state',
						width:120,
						align:'center',
						render: (h, params) => {
							if(params.row.state==true){
								return h("div",{style:{color:'green'}},"启用") 
							}else{
								return h("div",{style:{color:'red'}},"禁用") 
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align:'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
				data6: [
						/* {
							 id:'1',
							createdTime:'2019-01-01',
							name:'张三',
							phone:'13647631547',
							address:'重庆市渝北区',
							state:'启用' 
						} */
				],
				modal2: false,
				modal_loading: false,
				deleteId:'',
				//查询参数
				query:{
					page:0,
					size:10,
					districtId:''
				},
				query1:{
					page:0,
					size:10,
					districtId:''
				}
			}
		},
		methods: {
			onChange(a){
				console.log(a)
				this.queryDistrict.parentId=a[a.length-1]
				this.query1.districtId=a[a.length-1]
				this.query1.page=0
				this.ajax()
				
			},
			loadData(item, callback){
				let _this=this
				
			    item.loading = true;
				_this.query.parentId=item.value
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/district/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						let a1=0
						for (let i = 0; i < data.districts.content.length; i++) {
							let aa=data.districts.content[i]
							if(aa.isLower==true){
								let	a1={
										value: '',
										label: '',
										children: [],
										loading: false
								}
								a1.value=aa.id
								a1.label=aa.title
							    item.children.push(a1)
							}else{
								let	a1={
										value: '',
										label: ''
								}
								a1.value=aa.id
								a1.label=aa.title
							    item.children.push(a1)
							}
						}
						item.loading = false;
						callback();
						
					}
				  })
			},
			queryD(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/district/page',
				    data: _this.queryDistrict,
					_this: _this,
					success: function(data) {
						for (let i = 0; i < data.districts.content.length; i++) {
							let aa=data.districts.content[i]
							if(aa.isLower==true){
								let	a1={
										value: '',
										label: '',
										children: [],
										loading: false
								}
								a1.value=aa.id
								a1.label=aa.title
								_this.data4.push(a1)
							}else{
								let	a1={
										value: '',
										label: ''
								}
								a1.value=aa.id
								a1.label=aa.title
								_this.data4.push(a1)
							}
							
						}
					}
				  })
			},
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			reset(){//重置密码
			    let _this=this
			    http.http({
			        //这里是你自己的请求方式、url和data参数
			        method: 'post',
			        url: http.url + '/plat/oper/emp/update/password',
			        data: {id:_this.deleteId},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('重置密码成功!');
					}
			        //假设后台需要的是表单数据这里你就可以更改
			      })
				
			},
			update(id) { //修改
				this.$router.push({
					name: 'oper/emp/update',
					query:{id:id}
				})
			},
			add() {
				this.$router.push({
					name: 'oper/emp/add'
				})
			},
			updatePage(page){//页码改变的回调，返回改变后的页码
				this.query1.page=page-1
				this.ajax()
			},
			updateSize(size){//切换每页条数时的回调，返回切换后的每页条数
				this.query1.size=size
				this.ajax()
			},
			ajax(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/emp/page',
				    data: _this.query1,
					_this: _this,
					success: function(data) {
						_this.total=data.empPage.totalElements
						_this.data6=data.empPage.content
						  _this.loading=false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){//请求数据
		let _this=this
			this.ajax();
			this.queryD()
		}
		
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/emp/list.vue